import React from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'
import { createNgReactBridgeDirective } from '../../ng/react-bridge'

const RemoteScanProjectsPage = React.lazy(
  //@ts-expect-error
  () => import('orgSettings/scan-projects')
)

export const ScanProjectsPage = () => {
  return (
    <RemoteComponent testId="scan-projects">
      <RemoteScanProjectsPage />
    </RemoteComponent>
  )
}

export const reactScanProjectsPage = createNgReactBridgeDirective(
  'reactScanProjectsPage',
  [],
  ScanProjectsPage,
  []
)
